import { ReactNode, createContext, useContext } from "react";
import { useTablaCarritoV2, useTablaCarritoV2Props, ViewAs } from "./useTablaCarritoV2";

interface TablaCarpetaContextType {
    context: useTablaCarritoV2Props;
}

const TablaCarpetaContext = createContext<TablaCarpetaContextType | undefined>(undefined);

export const useTablaCarpetaContext = () => {
    const context = useContext(TablaCarpetaContext);
    if (!context) {
        throw new Error("useTablaCarpetaContext must be used within a TablaCarpetaProvider");
    }
    return context;
};

export const TablaCarpetaProvider = ({ children, viewAs = ViewAs.USER, isForEmpresa = false }: { children: ReactNode, viewAs?: useTablaCarritoV2Props['viewAs'], isForEmpresa?: boolean }) => {
    const context = useTablaCarritoV2(viewAs, isForEmpresa);

    return (
        <TablaCarpetaContext.Provider value={{ context }}>
            {children}
        </TablaCarpetaContext.Provider>
    );
};

